import { render } from "./JobChangeRole.vue?vue&type=template&id=89f6febc"
import script from "./JobChangeRole.vue?vue&type=script&lang=js"
export * from "./JobChangeRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__